<ng-scrollbar class="position-relative" style="height: 100%">
  <div class="d-flex align-items-center p-24 gap-16">
    <img
      [src]="avatar_url"
      class="rounded-circle"
      width="54"
      height="54"
    />
    <div>
      <h4 class="f-s-16 f-w-600">
        @if (technician) {
          {{ technician.name }} {{ technician.lastname }}
        }
      </h4>
      <span class="f-s-14 text-muted">
         @if (technician) {
           {{ technician.email }}
         }
      </span>
    </div>
  </div>

  <div class="m-x-24">
    <mat-nav-list class="chat-listing">
      @for (room of listRooms; track room.id) {
        <mat-list-item
          role="listitem"
          [disabled]="room.connected && room.connectionNumber === 2 && room.uuid != uuid"
          (click)="changeRoom(room.uuid)"
          [class.room-item--current]="room.uuid==uuid"
          [class.room-item--waiting]="room.connected && room.connectionNumber === 1"
          [class.room-item--busy]="room.connected && room.connectionNumber === 2 && room.uuid!=uuid"
          class="room-item m-b-2 gap-12">
          {{ room.name }} - {{ room.technician?.name }} {{ room.technician?.lastname }}
        </mat-list-item>
      }
    </mat-nav-list>
  </div>
</ng-scrollbar>
